import * as types from './types';

export const setToast = (toast) => ({
  type: types.SET_TOAST,
  payload: toast,
});
